import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import IconText from '../../a/IconText'
import Input from '#components/a/form/Input'
import WorkingHour from '#components/svg/icons/WorkingHour'

const handleUnsetOfWorktime = time => {
  return time >= 0 ? time : 0
}

function TaetigkeitWorktime({
  isDisabled,
  taetigkeitId,
  stunden,
  minuten,
  updateTaetigkeit,
  updateStunden,
  updateMinuten,
}) {
  const timeIsEmpty = stunden !== 0 || minuten !== 0
  const [showTime, setShowTime] = useState(timeIsEmpty)
  const displayTime = isDisabled || showTime
  return (
    <div className="taetigkeit__worktime">
      {displayTime ? (
        <>
          <WorkingHour />
          <Input
            dataType="stunden"
            isDisabled={isDisabled}
            id={`taetigkeitInput_stunden_${taetigkeitId}`}
            labelText="h"
            labelPosition="right"
            maxLength={3}
            modifier="timeInput"
            name="hours"
            onBlurHandle={updateTaetigkeit}
            onChangeHandle={elem => updateStunden(handleUnsetOfWorktime(elem.target.value))}
            pattern="[0-9]*"
            placeholder="0"
            value={stunden.toString()}
            type="number"
          />
          <Input
            dataType="minuten"
            isDisabled={isDisabled}
            id={`taetigkeitInput_minuten_${taetigkeitId}`}
            labelText="m"
            labelPosition="right"
            maxLength={3}
            modifier="timeInput"
            name="minutes"
            onBlurHandle={updateTaetigkeit}
            onChangeHandle={elem => updateMinuten(handleUnsetOfWorktime(elem.target.value))}
            pattern="[0-9]*"
            placeholder="0"
            value={minuten.toString()}
            type="number"
          />
        </>
      ) : (
        <IconText
          id={`taetigkeitInput_showTime_${taetigkeitId}`}
          icon="clock"
          event={setShowTime}
          modifier="blue"
          text={i18n.t('taetigkeit_showtime')}
        />
      )}
    </div>
  )
}

TaetigkeitWorktime.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  taetigkeitId: PropTypes.string.isRequired,
  stunden: PropTypes.number.isRequired,
  minuten: PropTypes.number.isRequired,
  updateTaetigkeit: PropTypes.func.isRequired,
  updateStunden: PropTypes.func.isRequired,
  updateMinuten: PropTypes.func.isRequired,
}

export default TaetigkeitWorktime
